import { render, staticRenderFns } from "./DigitalWorkshopComp.vue?vue&type=template&id=1b4ca66a&scoped=true"
import script from "./DigitalWorkshopComp.vue?vue&type=script&lang=js"
export * from "./DigitalWorkshopComp.vue?vue&type=script&lang=js"
import style0 from "./DigitalWorkshopComp.vue?vue&type=style&index=0&id=1b4ca66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ca66a",
  null
  
)

/* custom blocks */
import block0 from "./DigitalWorkshopComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports